export default __webpack_public_path__ + "static/media/whale.ac91788b.png";